<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-breaking-world-chronicles-book-two">
<h1 style="padding-top:250px; font-family:Arial; letter-spacing:3px;">The Breaking World Chronicles<br/> Book Two</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?53ff868f